/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BuccalCenter1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BuccalCenter from 'DesignSystem/Images/BuccalCenter/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function BuccalCenter1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration/BuccalCenter"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<BuccalCenter
  viewPath={`${viewPath}/BuccalCenter`}
 width="100%"
 height="100%"
 objectFit="contain"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
}